var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1.49231 1.55814 3.16618 2.67441 5.92314 2.67441C8.6801 2.67441 10.6822 1.55814 11.3386 1",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8303 1C12.3226 1.55814 13.9965 2.67441 16.7535 2.67441C19.5104 2.67441 21.5125 1.55814 22.1689 1",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6616 1C23.1539 1.55814 24.8278 2.67441 27.5848 2.67441C30.3417 2.67441 32.3438 1.55814 33.0002 1",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.81396C1.49231 9.3721 3.16618 10.4884 5.92314 10.4884C8.6801 10.4884 10.6822 9.3721 11.3386 8.81396",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8303 8.81396C12.3226 9.3721 13.9965 10.4884 16.7535 10.4884C19.5104 10.4884 21.5125 9.3721 22.1689 8.81396",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6616 8.81396C23.1539 9.3721 24.8278 10.4884 27.5848 10.4884C30.3417 10.4884 32.3438 9.3721 33.0002 8.81396",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5117C1.49231 16.0699 3.16618 17.1861 5.92314 17.1861C8.6801 17.1861 10.6822 16.0699 11.3386 15.5117",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8303 15.5117C12.3226 16.0699 13.9965 17.1861 16.7535 17.1861C19.5104 17.1861 21.5125 16.0699 22.1689 15.5117",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6616 15.5117C23.1539 16.0699 24.8278 17.1861 27.5848 17.1861C30.3417 17.1861 32.3438 16.0699 33.0002 15.5117",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.3257C1.49231 23.8838 3.16618 25.0001 5.92314 25.0001C8.6801 25.0001 10.6822 23.8838 11.3386 23.3257",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8303 23.3257C12.3226 23.8838 13.9965 25.0001 16.7535 25.0001C19.5104 25.0001 21.5125 23.8838 22.1689 23.3257",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6616 23.3257C23.1539 23.8838 24.8278 25.0001 27.5848 25.0001C30.3417 25.0001 32.3438 23.8838 33.0002 23.3257",
    stroke: "#1189C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.440b74eb9525575ef727d4b31c06e3fa.svg";
export { ForwardRef as ReactComponent };